export const DEFAULT_CURRENCY = process.env.DEFAULT_CURRENCY || "S$";

export const formatPrice = (
  value?: number,
  currency: string = DEFAULT_CURRENCY
) => {
  if (value === null || value === undefined) return;

  return `${currency} ${(Number(value) ?? 0).toFixed(2)}`;
};

// API sends money as cents (integer, sometimes fractional for per-unit rates).
export const formatCents = (
  cents?: number | null,
  currency: string = DEFAULT_CURRENCY
) => {
  if (cents === null || cents === undefined) return;

  return `${currency} ${(Number(cents) / 100).toFixed(2)}`;
};

export const formatPriceWithCommas = (
  value: number | string,
  currency: string = DEFAULT_CURRENCY
): string => {
  const number = typeof value === "string" ? parseFloat(value) : value;
  const formattedNumber = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
  return `${currency} ${formattedNumber}`;
};

export const formatNumber = (value?: number) => {
  var locales = [undefined, "en-US", "de-DE", "ru-RU", "hi-IN", "de-CH"];
  var n = value ?? 0;
  var opts = { minimumFractionDigits: 0 };
  return n.toLocaleString(locales[0], opts);
};

export const formatWithCommas = (value: number | string): string => {
  const number = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(number)) return "0";
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(number);
};

export const toTitleCase = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/[-_.\s]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatFeeAmount = (value?: number | null): string => {
  if (value === null || value === undefined) {
    return "-";
  }

  return formatPrice(value) ?? "-";
};

// NDT-1511: a charge session records how it was initiated in `started_by`. Sessions created
// before the Plug & Charge rollout have no value at all, so they must read as "Unknown" —
// falling back to "Mobile App" would misreport them as app-started.
const STARTED_BY_LABEL: Record<string, string> = {
  plug_n_charge: "Plug & Charge",
  mobile_app: "Mobile App",
};

export const formatStartedBy = (value?: string | null): string => {
  if (!value) return "Unknown";

  return STARTED_BY_LABEL[value] ?? toTitleCase(value);
};

export const getDiffObject = (oldPayload: any, newPayload: any) => {
  const diffs: string[] = [];

  if (!newPayload) return [];

  delete oldPayload?.updatedAt;
  delete newPayload?.updatedAt;
  delete oldPayload?.password;
  delete newPayload?.password;

  for (const key in newPayload) {
    const oldValue = oldPayload?.[key];
    const newValue = newPayload[key];

    if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
      diffs.push(`${key}: ${oldValue ?? "null"} -> ${newValue}`);
    }
  }

  return diffs;
};
